import { render } from "./InquiryFindings.vue?vue&type=template&id=071d479b&scoped=true"
import script from "./InquiryFindings.vue?vue&type=script&lang=js"
export * from "./InquiryFindings.vue?vue&type=script&lang=js"

import "./InquiryFindings.vue?vue&type=style&index=0&id=071d479b&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071d479b"]])

export default __exports__